module.exports = "/_next/static/images/TechnologyDeploymentCardImage-9942b0087f69b8433bf77511db00f7cb.webp";